import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import Completed from "./images/completed.svg";
import Verified from "./images/verified.svg";
import { REQUIRED_DOCUMENTS_CATEGORY } from "../post-inspection-diy/constant";

const DocumentPopup = ({
    requiredDocumentList,
    title = ""
}) => {

    return (
        <div styleName={"styles.documentPopupWrapper"}>
            <div styleName={"styles.documentHeader"}>
                <img src={Completed} alt="completed" />
                {title && <h4>{title}</h4>}
            </div>
            { !!(requiredDocumentList && Object.keys(requiredDocumentList) && Object.keys(requiredDocumentList).length) &&
                Object.keys(requiredDocumentList).map((element, index) => (
                    <React.Fragment key={index} >
                        <p styleName={"styles.documentCategory"}>{REQUIRED_DOCUMENTS_CATEGORY[element]}</p>
                        {
                            !!(requiredDocumentList[element] && requiredDocumentList[element].length) &&
                            requiredDocumentList[element].map((doc, i) => (
                                <div styleName={"styles.documentWrapper"} key={i} >
                                    <p>{doc.name}</p>
                                    <div styleName={"styles.documentVerifiedStatus"}>
                                        <img src={Verified} alt="verified"/>
                                        <span>VERIFIED</span>
                                    </div>
                                </div>
                            ))
                        }
                    </React.Fragment>
                ))}
        </div>
    );
};

DocumentPopup.propTypes = {
    requiredDocumentList: PropTypes.object,
    title: PropTypes.string
};

export default DocumentPopup;
